import React from 'react';
import Script from 'next/script';
import { NEXT_PUBLIC_KNOTCH_LC_LAYOUT_ACCOUNT_ID } from '../../server/config';

const LearningCenterLayout = ({ children }) => (
    <React.Fragment>
        <Script
            src={`https://www.knotch-cdn.com/ktag/latest/ktag.min.js?accountId=${NEXT_PUBLIC_KNOTCH_LC_LAYOUT_ACCOUNT_ID}`}
        />
        {children}
    </React.Fragment>
);

export default LearningCenterLayout;
